import { type QueryKey } from "@tanstack/react-query";
import { type AxiosPromise } from "axios";
import { Loading, Panel } from "components/panels";
import React from "react";
import { useInfiniteScrollQuery } from "utilities/hookutils";
import { AdvancingActivityRow } from "./AdvancingActivityRow";

export interface AdvancingActivitySource {
  queryKey: QueryKey
  fetchPage: (page: number, perPage: number) => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.AdvancingSessionActivity[]>>
}

interface Props {
  source: AdvancingActivitySource
}

const perPage = 25;

export const useAdvancingActivityQuery = (source: AdvancingActivitySource) => useInfiniteScrollQuery(
  [...source.queryKey, "infinite"],
  page => source.fetchPage(page, perPage)
);

export const AdvancingActivityLog = ({ source }: Props) => {
  const { query, items, loadMoreRef } = useAdvancingActivityQuery(source);

  return <Panel
    panelClassName="s1_panel advancing-activity-panel"
    contentCssClass="advancing-activity-panel-content"
    title={RESX.Activity.resxActivity}
    isLoading={query.isLoading}
  >
    <div className="advancing-activity-list">
      {items.map(activity => <AdvancingActivityRow key={activity.activityId} activity={activity} />)}
      <div ref={loadMoreRef} />
      {query.isFetchingNextPage && <Loading />}
    </div>
  </Panel>;
};
